import type { ID } from '@octopus-do/octopus-project-core'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { UserItemMenuBtn, UserItemMenuContent } from './components'
import { useUserItemMenu } from './useUserItemMenu'

interface Props {
  id: ID
  buttonCn: string
  changesShown: boolean
  onSetChangesIsOpen: (id: string | null) => void
  onRestore: () => void
}

export const UserItemMenu: React.FC<Props> = ({
  id,
  buttonCn,
  changesShown,
  onSetChangesIsOpen,
  onRestore,
}) => {
  const { onClick } = useUserItemMenu(
    id,
    changesShown,
    onSetChangesIsOpen,
    onRestore
  )

  return (
    <DropdownMenu.Root
      align="end"
      content={UserItemMenuContent}
      changesShown={changesShown}
      onClick={onClick}
    >
      <UserItemMenuBtn className={buttonCn} />
    </DropdownMenu.Root>
  )
}
